import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import MonitoringPushModal from 'components/atoms/monitoring_push_modal';
import MonitoringNotificationTests from 'components/molecules/monitoring_notification_tests';
import MonitoringNotificationSettings from 'components/organisms/monitoring_notification_settings';
import { useMonitoringSettings } from 'hooks/useMonitoringSettings';
import { ApplicationState } from 'store';
import { ProfileState } from 'store/modules/profile_store/types';
import LegacyMonitoringConfiguration from './legacy';
import { Container } from './styles';

const MonitoringConfiguration: React.FC = () => {
  const settings = useMonitoringSettings();
  const [pushModalOpened, setPushModalOpened] = useState<boolean>(false);

  useEffect(() => {
    document.title = 'Configurações do Monitorar Chat - ConLicitação';
  }, []);

  return (
    <Container>
      <div className="page-container">
        <div className="container p-4">
          <div className="row mb-3">
            <div className="col-12">
              <Link to="/facilitadores/monitoramento">
                <i className="material-icons align-middle">keyboard_arrow_left</i> Voltar para o
                Monitoramento
              </Link>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <h4 className="mb-3">Configurações gerais do Monitoramento</h4>
              <MonitoringNotificationSettings
                settings={settings}
                onActivateDesktop={() => setPushModalOpened(true)}
              />
              <MonitoringNotificationTests companyId={settings.company} />
            </div>
          </div>
        </div>
      </div>
      <MonitoringPushModal
        pushEnabled={settings.permission}
        monitoringNotificationModalOpened={pushModalOpened}
        setMonitoringNotificationModalOpened={setPushModalOpened}
      />
    </Container>
  );
};

const MonitoringConfigurationPage: React.FC = () => {
  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);

  return profile.alfa_tester ? <MonitoringConfiguration /> : <LegacyMonitoringConfiguration />;
};

export default MonitoringConfigurationPage;
